import React from 'react';

import {GridType} from 'constants/SampleConstants';
import {BoxCreationTableMetadata} from 'notebook/integrations/samples/BoxCreationStructuredTableAdapter';
import {PlateCreationTableMetadata} from 'notebook/integrations/samples/PlateCreationStructuredTableAdapter';
import SimpleTableEditable, {standaloneProps} from 'notebook/simple-tables/SimpleTableEditable';
import {
  SchemaAndColumnGroup,
  StructuredTableKind,
  UnknownStructuredTableAdapter,
} from 'notebook/structured-tables/StructuredTableConstants';
import kindToIcon from 'notebook/structured-tables/util/kindToIcon';
import {StructuredTableInsertionContextValue} from 'notebook/structured-tables/util/StructuredTableInsertionContext';
import {SchemaFieldSelector} from 'schemas/SchemaFieldSelectorConstants';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import {assertNever} from 'util/Types';

interface GridCreationTablePreviewProps {
  gridType: GridType;
  schema: SchemaAndColumnGroup;
  adapter: UnknownStructuredTableAdapter;
  cid: string;
  selectorsById: {[selectorId: string]: SchemaFieldSelector} | null;
  metadata: BoxCreationTableMetadata | PlateCreationTableMetadata;
  structuredTableInsertionContext: StructuredTableInsertionContextValue;
}

function iconFor(gridType: GridType): string {
  switch (gridType) {
    case GridType.BOX:
      return kindToIcon(StructuredTableKind.BOX_CREATION);
    case GridType.PLATE:
      return kindToIcon(StructuredTableKind.PLATE_CREATION);
    default:
      assertNever(gridType);
      return '';
  }
}

export function GridCreationTablePreview(props: GridCreationTablePreviewProps): JSX.Element {
  const structuredTable = {
    ...props.adapter.createTable({
      name: props.schema.name,
      schemas: [props.schema],
      entryId: 'etr_gridCreationPreviewTable',
      metadata: props.metadata,
      selectorsById: props.selectorsById || {},
      structuredTableInsertionContext: props.structuredTableInsertionContext,
    }),
    cid: props.cid,
  };

  const table = props.adapter.toTable(props.adapter.prepareForPreview(structuredTable));

  return (
    <FormGroup className="u-spacing-top">
      <Label>Preview</Label>
      <div className="modal-mediocre-tableWrapper">
        <SimpleTableEditable
          {...standaloneProps}
          table={table}
          cid={props.cid}
          locked={true}
          hideFormulaBox={true}
          viewer={true}
          icon={iconFor(props.gridType)}
          enableFormulas={false}
          hasPlaceholderRows={true}
          storeState={() => {}}
          tableLabel={props.adapter.getDisplayName(structuredTable)}
          isLeftAlignColumnHeader={true}
        />
      </div>
    </FormGroup>
  );
}
